module.exports = __webpack_public_path__ + "assets/img/bg3.bb0e1ae9.png";